
export const LOGOUT_SHOWMESSAGE = "LOGOUT_SHOWMESSAGE";

export const SHOW_ERROR = "SHOW_ERROR";
export const SHOW_SPINNY = "SHOW_SPINNY";
export const SET_SIMS = "SET_SIMS";
export const SET_PACKETLOGS = "SET_PACKETLOGS";
export const SET_COUPONHISTORY = "SET_COUPONS";

export const REST_SERVER = process.env.REACT_APP_REST_SERVER||"";